export default "__VITE_ASSET__BOXPwyCN__"